import type { PortableTextBlock } from '@portabletext/types';
import { Faqs } from '@time-line/components/blocks';
import type { FaqListItem } from '@time-line/components/common';
import { JsonLd } from 'components/common/JsonLd';
import { RichTextResolver } from 'components/common/RichTextResolver';
import * as routes from 'lib/constants/routes';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { buildFaqPage, productFaqId } from 'utils/jsonld';

interface ProductFaqProps {
  title: string;
  list: FaqListItem[];
  subtitle?: PortableTextBlock[];
  isFAQLinkEnabled?: boolean;
}

export function ProductFaq({
  title,
  list,
  subtitle,
  isFAQLinkEnabled,
}: ProductFaqProps) {
  const router = useRouter();

  const schema = useMemo(
    () =>
      buildFaqPage({
        entries: list,
        pagePath: router.asPath,
        variant: 'product',
      }),
    [list, router.asPath],
  );

  return (
    <>
      {schema && (
        <JsonLd scriptKey={productFaqId(router.asPath)} schema={schema} />
      )}
      <Faqs
        RichTextResolver={RichTextResolver}
        title={title}
        list={list}
        seeAllQuestionsHref={isFAQLinkEnabled ? routes.FAQ : undefined}
        subtitle={subtitle}
      />
    </>
  );
}
